export default __webpack_public_path__ + "c3244f81baec7800062aad1a0706d5c9.png";